import styled from 'styled-components';

const Tooltip = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipText = styled.span`
  visibility: hidden;
  width: 60px;
  background-color: rgb(36, 188, 252);
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 120%;
  left: 50%;
  margin-left: -33px;
  font-size: 12px;
  box-shadow: 5px 5px 5px rgba(29, 66, 186, 0.5);
  opacity: 0;
  &:after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgb(36, 188, 252) transparent;
  }
  ${Tooltip}:hover & {
    visibility: visible;
    opacity: 1;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
`;

export default Tooltip;
export { TooltipText };
